import { render } from "./consuleLieSi.vue?vue&type=template&id=a23a4fa6&scoped=true"
import script from "./consuleLieSi.vue?vue&type=script&lang=js"
export * from "./consuleLieSi.vue?vue&type=script&lang=js"

import "./consuleLieSi.vue?vue&type=style&index=0&id=a23a4fa6&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23a4fa6"]])

export default __exports__